import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FaEnvelope, FaClock } from 'react-icons/fa6';
import api from '../../api/api';
import { useNotification } from '../../hooks/useNotification';
import './ContactPage.css';

const COUNTRIES = ['India', 'United States', 'United Kingdom', 'Canada', 'Australia', 'Germany', 'France', 'Singapore', 'UAE', 'Other'];

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', country: '', email: '', phoneNumber: '', query: '' });
  const [loading, setLoading] = useState(false);
  const { show, NotificationBar } = useNotification();

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    if (!form.name || !form.email || !form.query) {
      show('Please fill in all required fields', 'error');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/contact', form);
      if (res.data.success) {
        show(res.data.message, 'success');
        setForm({ name: '', country: '', email: '', phoneNumber: '', query: '' });
      }
    } catch {
      show('Failed to submit. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact Us | EffyVenture — Get in Touch</title>
        <meta name="description" content="Have questions about EffyVenture? Contact us for support, feature requests, or partnerships. We respond within 24 hours." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.effyventure.com/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.effyventure.com/contact" />
        <meta property="og:site_name" content="EffyVenture" />
        <meta property="og:title" content="Contact Us | EffyVenture — Get in Touch" />
        <meta property="og:description" content="Have questions about EffyVenture? Contact us for support, feature requests, or partnerships. We respond within 24 hours." />
        <meta property="og:image" content="https://www.effyventure.com/logo/logo-512.png" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Contact Us | EffyVenture — Get in Touch" />
        <meta name="twitter:description" content="Have questions about EffyVenture? Contact us for support, feature requests, or partnerships. We respond within 24 hours." />
      </Helmet>
      <NotificationBar />
      <div className="contact-page__inner">
        <div className="contact-page__left">
          <div className="contact-page__tag">Get In Touch</div>
          <h1>We'd love to<br />hear from you</h1>
          <p>Have questions about our products? Want to request a feature? Or just want to say hello? Drop us a message and we'll get back to you within 24 hours.</p>
          <div className="contact-page__info">
            <div className="contact-info-item"><span><FaEnvelope /></span> info@effyventure.com</div>
            <div className="contact-info-item"><span><FaClock /></span> Response within 24 hours</div>
          </div>
        </div>

        <div className="contact-page__right">
          <form className="card contact-form shine-rail" onSubmit={submit}>
            <h2>Send a Message</h2>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Full Name *</label>
                <input className="input-field" name="name" value={form.name} onChange={handle} placeholder="John Doe" required />
              </div>
              <div className="form-group">
                <label className="form-label">Country</label>
                <select className="select-field" name="country" value={form.country} onChange={handle}>
                  <option value="">Select country</option>
                  {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Email Address *</label>
                <input className="input-field" type="email" name="email" value={form.email} onChange={handle} placeholder="john@example.com" required />
              </div>
              <div className="form-group">
                <label className="form-label">Phone Number</label>
                <input className="input-field" name="phoneNumber" value={form.phoneNumber} onChange={handle} placeholder="+91 99999 99999" />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Your Message *</label>
              <textarea className="input-field contact-form__textarea" name="query" value={form.query} onChange={handle} placeholder="Tell us how we can help you..." required rows={5} />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '13px' }} disabled={loading}>
              {loading ? <><span className="spinner" />Sending...</> : 'Send Message →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
